module.exports = {
  "general.printers": "Printers",
  "general.charts": "Execution Widgets",
  "general.close": "Close out",
  "sidebar.app": "Home",
  "sidebar.shipments": "Shipments",
  "sidebar.shipment": "Shipment",
  "sidebar.sedSettings": "SED/EEI Settings",
  "sidebar.createCompany": "Add New Company",
  "sidebar.shipmentRecord": "Shipment Record",
  "sidebar.sliSettings": "SLI Settings",
  "sidebar.notes": "Notes",
  "sidebar.stock": "Stock",
  "sidebar.all": "All",
  "sidebar.purchaseOrders": "Purchase Orders",
  "sidebar.purchaseOrder": "Purchase Order",
  "sidebar.news": "News",
  "sidebar.reports": "Reports",
  "sidebar.horizontal": "Horizontal",
  "sidebar.horizontalMenu": "Horizontal Menu",
  "sidebar.storage": "Storage",
  "sidebar.carton": "Carton",
  "sidebar.location": "Location",
  "sidbar.skid": "Skid",
  "sidebar.general": "General",
  "sidebar.component": "Component",
  "sidebar.features": "Features",
  "sidebar.applications": "Applications",
  "sidebar.dashboard": "Dashboard",
  "sidebar.whsRecpts": "Warehouse Receipts",
  "sidebar.dashboard1": "Dashboard 1",
  "sidebar.dashboard2": "Dashboard 2",
  "sidebar.dashboard3": "Dashboard 3",
  "sidebar.company": "Company",
  "sidebar.modules": "Modules",
  "sidebar.agency": "Agency",
  "sidebar.pages": "Pages",
  "sidebar.gallery": "Gallery",
  "sidebar.pricing": "Pricing",
  "sidebar.termsConditions": "Terms & Conditions",
  "sidebar.feedback": "Feedback",
  "sidebar.report": "Report",
  "sidebar.faq(s)": "Faq(s)",
  "sidebar.advancedComponent": "Advance Component",
  "sidebar.blank": "Blank",
  "sidebar.session": "Session",
  "sidebar.login": "Login",
  "sidebar.register": "Register",
  "sidebar.lockScreen": "Lock Screen",
  "sidebar.forgotPassword": "Forgot Password",
  "sidebar.404": "404",
  "sidebar.500": "500",
  "sidebar.uiComponents": "UI Components",
  "sidebar.alerts": "Alerts",
  "sidebar.appBar": "App Bar",
  "sidebar.avatars": "Avatars",
  "sidebar.buttons": "Buttons",
  "sidebar.bottomNavigations": "Bottom Navigations",
  "sidebar.badges": "Badges",
  "sidebar.cards": "Cards",
  "sidebar.cardsMasonry": "Cards Masonry",
  "sidebar.chip": "Chip",
  "sidebar.dialog": "Dialog",
  "sidebar.dividers": "Dividers",
  "sidebar.drawers": "Drawers",
  "sidebar.popover": "Popover",
  "sidebar.expansionPanel": "Expansion Panel",
  "sidebar.gridList": "Grid List",
  "sidebar.list": "List",
  "sidebar.menu": "Menu",
  "sidebar.popoverAndToolTip": "Pop Over & ToolTip",
  "sidebar.progress": "Progress",
  "sidebar.snackbar": "Snackbar",
  "sidebar.selectionControls": "Selection Controls",
  "sidebar.advanceUiComponents": "Advance UI Components",
  "sidebar.dateAndTimePicker": "Date & Time Picker",
  "sidebar.tabs": "Tabs",
  "sidebar.stepper": "Stepper",
  "sidebar.notification": "Notification",
  "sidebar.sweetAlert": "Sweet Alert",
  "sidebar.autoComplete": "Auto Complete",
  "sidebar.aboutUs": "About Us",
  "sidebar.widgets": "Widgets",
  "sidebar.forms": "Forms",
  "sidebar.formElements": "Form Elements",
  "sidebar.textField": "Text Field",
  "sidebar.selectList": "Select List",
  "sidebar.charts": "Charts",
  "sidebar.reCharts": "Re Charts",
  "sidebar.reactChartjs2": "React Chartjs 2",
  "sidebar.icons": "Icons",
  "sidebar.themifyIcons": "Themify Icons",
  "sidebar.simpleLineIcons": "Simple Line Icons",
  "sidebar.materialIcons": "Material Icons",
  "sidebar.fontAwesome": "Font Awesome",
  "sidebar.tables": "Tables",
  "sidebar.basic": "Basic",
  "sidebar.dataTable": "Data Table",
  "sidebar.responsive": "Responsive",
  "sidebar.reactTable": "React Table",
  "sidebar.maps": "Maps",
  "sidebar.googleMaps": "Google Maps",
  "sidebar.leafletMaps": "Leaflet Maps",
  "sidebar.inbox": "Inbox",
  "sidebar.users": "Users",
  "sidebar.userProfile1": "User Profile 1",
  "sidebar.userProfile2": "User Profile 2",
  "sidebar.userManagement": "User Management",
  "sidebar.userProfile": "User Profile",
  "sidebar.userList": "User List",
  "sidebar.calendar": "Calendar",
  "sidebar.cultures": "Cultures",
  "sidebar.dnd": "Dnd",
  "sidebar.selectable": "Selectable",
  "sidebar.customRendering": "Custom Rendering",
  "sidebar.chat": "Chat",
  "sidebar.toDo": "ToDo",
  "sidebar.editor": "Editor",
  "sidebar.wysiwygEditor": "WYSIWYG Editor",
  "sidebar.quillEditor": "Quill Editor",
  "sidebar.reactAce": "React Ace",
  "sidebar.dragAndDrop": "Drag And Drop",
  "sidebar.whsRecpt": "Warehouse Receipts",
  "sidebar.details": "Details",
  "sidebar.reactDragula": "React Dragula",
  "sidebar.reactDnd": "React Dnd",
  "sidebar.blogManagement": "Blog Management",
  "sidebar.ecommerce": "Ecommerce",
  "sidebar.shopList": "Shop List",
  "sidebar.shopGrid": "Shop Grid",
  "sidebar.invoice": "Invoice",
  "sidebar.multilevel": "Multilevel",
  "sidebar.sublevel": "Sublevel",
  "sidebar.deleteme": "Deleteme",
  "sidebar.new": "New",
  "sidebar.settings": "Settings",
  "sidebar.workOrder": "Work Orders",
  "sidebar.tickets": "Tickets",
  "sidebar.handlingUnit": "Handling Units",
  //General
  "general.quantity": "Qty",
  "general.next": "Next",
  "general.previous": "Previous",
  "general.filter": "Filter",
  "general.to": "To",
  "general.from": "From",
  "general.details": "Details",
  "general.approve": "Approve",
  "general.name": "Name",
  "general.create": "Create",
  "general.copied": "Copied",
  "general.handlingUnitExist": "Handling Unit Already Exists",
  "general.submit": "submit",
  "general.cancel": "cancel",
  "general.invalidInput": "Invalid input",
  "general.notes": "Notes",
  "general.search": "Search...",
  "general.none": "NONE",
  "general.select": "Select",
  "general.adhoc": "Ad Hoc",
  "general.regular": "Regular",
  "general.addOrRemoveCol": "+/- Columns",
  "general.contactSupport": "Contact Support",
  "general.inProgress": "In Progress..",
  "general.companies": "Companies",
  "general.languages": "Languages",
  "general.quickLinks": "Quick Links",
  "general.click": "Click",
  "general.searchAddress": "Search Consignee",
  "general.streetOne": "Street 1 / Company Name",
  "general.streetTwo": "Street 2",
  "general.streetThree": "Street 3",
  "general.city": "City",
  "general.state": "State",
  "general.postalCode": "Postal Code",
  "general.countries": "Country",
  "general.add": "Add",
  "general.done": "Done",
  "general.save": "Save",
  "general.created": "Created",
  "general.finalized": "Finalized",
  "general.unfinalized": "Unfinalized",
  "general.notFinalized": "Not Finalized",
  "general.empty": "Empty",
  "general.delete": "Delete",
  "general.update": "Update",
  "general.deleted": "Deleted",
  "general.printingLabels": "Labels sent to printer",
  "general.print": "Print",
  "general.printAllCartons": "Print All Carton Labels",
  "general.labelsError": "Error printing labels",
  "general.customer": "Customer",
  "general.remarks": "Remarks",
  "general.yes": "Yes",
  "general.no": "No",
  "general.addTracking": "Add Tracking",
  "general.loading": "Loading...",
  "general.addressSearch": "Address Search",
  "general.selectCustomer": "Select Customer",
  "general.updated": "Updated",
  "general.items": "Items",
  "general.unableToLoadItems": "Unable to load Items",
  "general.printerError": "Printer Error",
  "general.printLabel": "Print Label",
  "general.printLabels": "Print Labels",
  "general.refresh": "Refresh",
  "general.missingStreetOneCityORCountry": "Invalid Street 1, City, or Country",
  "general.requiredFields": "* Required fields",
  "general.addAll": "ADD ALL",
  "general.error": "Error",
  "general.clear": "Clear",
  "general.unableToSave": "Unable to save",
  "general.unauthorized": "Unauthorized",
  "general.addressCreated": "Address Created",
  "general.unableToUpdate": "Unable to Update",
  "general.resentCorrespondence": "Resending Latest Event Communication",
  "general.unableToResend":
    "There was a problem sending the latest communication",
  "general.resendCorrespondence": "Resend Latest Event Communication",
  "general.send": "Send",
  "general.email": "Email",
  "general.description": "Description",
  "general.active": "Active",
  "general.holdType": "Hold Type",
  "general.accessToCompanyData": "Access To Company Information",
  "general.DL": "Distribution List",
  //Widgets
  "widgets.totalEarns": "Total Earns",
  "widgets.emailsStatistics": "Emails Statistics",
  "widgets.weight": "Shipped Weight (Kgs)",
  "widgets.fob": "FOB Shipped ($)",
  "widgets.totalRevenue": "Total Revenue",
  "widgets.onlineVisitors": "Online Visitors",
  "widgets.trafficSources": "Traffic Sources",
  "widgets.RecentOrders": "Recent Orders",
  "widgets.topSellings": "Top Sellings",
  "widgets.productReports": "Product Reports",
  "widgets.productStats": "Product Stats",
  "widgets.ComposeEmail": "Compose Email",
  "widgets.employeePayroll": "Employee Payroll",
  "widgets.visitors": "Visitors",
  "widgets.orders": "Orders",
  "widgets.orderStatus": "Order Status",
  "widgets.totalSales": "Total Sales",
  "widgets.netProfit": "Net Profit",
  "widgets.overallTrafficStatus": "Overall Traffic Status",
  "widgets.tax": "Tax",
  "widgets.expenses": "Expenses",
  "widgets.currentTime": "Current Time",
  "widgets.currentDate": "Current Date",
  "widgets.todayOrders": "Today Orders",
  "widgets.toDoList": "To Do Lists",
  "widgets.discoverPeople": "Discover People",
  "widgets.comments": "Comments",
  "widgets.newCustomers": "New Customers",
  "widgets.recentNotifications": "Recent Notifications",
  "widgets.appNotifications": "App Notifications",
  "widgets.ratings": "Ratings",
  "widgets.newEmails": "New Emails",
  "widgets.siteVisitors": "Site Visitors",
  "widgets.socialCompanies": "Social Companies",
  "widgets.recentActivities": "Recent Activities",
  "widgets.recentOrders": "Recent Orders",
  "widgets.gallery": "Gallery",
  "widgets.pricing": "Pricing",
  "widgets.enterpriseEdition": "Enterprise Edition",
  "widgets.personalEdition": "Personal Edition",
  "widgets.teamEdition": "Team Edition",
  "widgets.standard": "Standard",
  "widgets.advanced": "Advanced",
  "widgets.master": "Master",
  "widgets.Mega": "Mega",
  "widgets.logIn": "Log In",
  "widgets.signUp": "Sign Up",
  "widgets.lockScreen": "Lock Screen",
  "widgets.alertsWithLink": "Alerts With Link",
  "widgets.additionalContent": "Additional Content",
  "widgets.alertDismiss": "Alert Dismiss",
  "widgets.uncontrolledDisableAlerts": "Uncontrolled Disable Alerts",
  "widgets.contextualAlerts": "Contextual Alerts",
  "widgets.alertsWithIcons": "Alerts With Icons",
  "widgets.Simple App Bars": "Simple App Bars",
  "widgets.appBarsWithButtons": "App Bars With Buttons",
  "widgets.imageAvatars": "Image Avatars",
  "widgets.lettersAvatars": "Letters Avatars",
  "widgets.iconsAvatars": "Icons Avatars",
  "widgets.flatButtons": "Flat Buttons",
  "widgets.raisedButton": "Raised Button",
  "widgets.buttonWithIconAndLabel": "Button With Icon And Label",
  "widgets.floatingActionButtons": "Floating Action Buttons",
  "widgets.iconButton": "Icon Button",
  "widgets.socialMediaButton": "Social Media Button",
  "widgets.reactButton": "React Button",
  "widgets.buttonOutline": "Button Outline",
  "widgets.buttonSize": "Button Size",
  "widgets.buttonState": "Button State",
  "widgets.buttonNavigationWithNoLabel": "button Navigation With No Label",
  "widgets.buttonNavigation": "Button Navigation",
  "widgets.iconNavigation": "Icon Navigation",
  "widgets.badgeWithHeadings": "Badge With Headings",
  "widgets.contextualVariations": "Contextual Variations",
  "widgets.badgeLinks": "Badge Links",
  "widgets.materialBadge": "Material Badge",
  "widgets.simpleCards": "Simple Cards",
  "widgets.backgroundVariant": "Background Variant",
  "widgets.cardOutline": "Card Outline",
  "widgets.overlayCard": "Overlay Card",
  "widgets.cardGroup": "Card Group",
  "widgets.cardTitle": "Card Title",
  "widgets.specialTitleTreatment": "Special Title Treatment",
  "widgets.chipWithClickEvent": "Chip With Click Event",
  "widgets.chipArray": "Chip Array",
  "widgets.dialogs": "Dialogs",
  "widgets.listDividers": "List Dividers",
  "widgets.insetDividers": "Inset Dividers",
  "widgets.temporaryDrawers": "Temporary Drawers",
  "widgets.permanentDrawers": "Permanent Drawers",
  "widgets.simpleExpansionPanel": "Simple Expansion Panel",
  "widgets.controlledAccordion": "Controlled Accordion",
  "widgets.secondaryHeadingAndColumns": "Secondary Heading And Columns",
  "widgets.imageOnlyGridLists": "Image Only Grid Lists",
  "widgets.advancedGridLists": "Advanced Grid Lists",
  "widgets.singleLineGridLists": "Single Line Grid Lists",
  "widgets.simpleLists": "Simple Lists",
  "widgets.folderLists": "Folder Lists",
  "widgets.listItemWithImage": "List Item With Image",
  "widgets.switchLists": "Switch Lists",
  "widgets.insetLists": "Inset Lists",
  "widgets.nestedLists": "Nested Lists",
  "widgets.checkboxListControl": "Checkbox List Control",
  "widgets.pinedSubHeader": "Pined Sub Header",
  "widgets.InteractiveLists": "Interactive Lists",
  "widgets.simpleMenus": "Simple Menus",
  "widgets.selectedMenu": "Selected Menu",
  "widgets.maxHeightMenu": "Max Height Menu",
  "widgets.changeTransition": "Change Transition",
  "widgets.paper": "Paper",
  "widgets.anchorPlayGround": "Anchor Play Ground",
  "widgets.tooltip": "ToolTip",
  "widgets.positionedToolTips": "Positioned Snackbar",
  "widgets.circularProgressBottomStart": "Circular Progress Bottom Start",
  "widgets.interactiveIntegration": "Interactive Integration",
  "widgets.determinate": "Determinate",
  "widgets.linearProgressLineBar": "Linear Progress Line Bar",
  "widgets.indeterminate": "Indeterminate",
  "widgets.buffer": "Buffer",
  "widgets.query": "Query",
  "widgets.transitionControlDirection": "Transition Control Direction",
  "widgets.simpleSnackbar": "Simple Snackbar",
  "widgets.positionedSnackbar": "Positioned Snackbar",
  "widgets.contextualColoredSnackbars": "Contextual Colored Snackbars",
  "widgets.simpleCheckbox": "Simple Checkbox",
  "widgets.indeterminateSelection": "Indeterminate Selection",
  "widgets.disabledCheckbox": "Disabled Checkbox",
  "widgets.customColorCheckbox": "Custom Color Checkbox",
  "widgets.VerticalStyleCheckbox": "Vertical Style Checkbox",
  "widgets.horizontalStyleCheckbox": "Horizontal Style Checkbox",
  "widgets.radioButtons": "Radio Buttons",
  "widgets.disabledRadio": "Disabled Radio",
  "widgets.withError": "With Error",
  "widgets.dateAndTimePicker": "Date And Time Picker",
  "widgets.defaultPicker": "Default Picker",
  "widgets.timePicker": "Time Picker",
  "widgets.weekPicker": "Week Picker",
  "widgets.defaultDatePicker": "Default Date Picker",
  "widgets.customPicker": "Custom Picker",
  "widgets.tabs": "Tabs",
  "widgets.fixedTabs": "Fixed Tabs",
  "widgets.basicTab": "Basic Tab",
  "widgets.wrappedLabels": "Wrapped Labels",
  "widgets.centeredLabels": "Centered Labels",
  "widgets.forcedScrolledButtons": "Forced Scrolled Buttons",
  "widgets.iconsTabs": "Icons Tabs",
  "widgets.withDisableTabs": "With Disable Tabs",
  "widgets.iconWithLabel": "Icon With Label",
  "widgets.stepper": "Stepper",
  "widgets.horizontalLinear": "Horizontal Linear",
  "widgets.horizontalNonLinear": "Horizontal Non Linear",
  "widgets.horizontalLinerAlternativeLabel":
    "Horizontal Liner Alternative Label",
  "widgets.horizontalNonLinerAlternativeLabel":
    "Horizontal Non Liner Alternative Label",
  "widgets.verticalStepper": "Vertical Stepper",
  "widgets.descriptionAlert": "Description Alert",
  "widgets.customIconAlert": "Custom Icon Alert",
  "widgets.withHtmlAlert": "With Html Alert",
  "widgets.promptAlert": "Prompt Alert",
  "widgets.passwordPromptAlert": "Password Prompt Alert",
  "widgets.customStyleAlert": "Custom Style Alert",
  "widgets.autoComplete": "Auto Complete",
  "widgets.reactSelect": "React Select",
  "widgets.downshiftAutoComplete": "Downshift Auto Complete",
  "widgets.reactAutoSuggests": "React Auto Suggests",
  "widgets.aboutUs": "About Us",
  "widgets.ourVision": "Our Vision",
  "widgets.ourMissions": "Our Missions",
  "widgets.ourMotivation": "Our Motivation",
  "widgets.defaultReactForm": "Default React Form",
  "widgets.url": "Url",
  "widgets.textArea": "Text Area",
  "widgets.file": "File",
  "widgets.formGrid": "Form Grid",
  "widgets.inlineForm": "Inline Form",
  "widgets.inputSizing": "Input Sizing",
  "widgets.inputGridSizing": "Input Grid Sizing",
  "widgets.hiddenLabels": "Hidden Labels",
  "widgets.formValidation": "Form Validation",
  "widgets.number": "Number",
  "widgets.date": "Date",
  "widgets.time": "Time",
  "widgets.color": "Color",
  "widgets.search": "Search",
  "widgets.selectMultiple": "Select Multiple",
  "widgets.inputWithSuccess": "Input With Success",
  "widgets.inputWithDanger": "Input With Danger",
  "widgets.simpleTextField": "Simple Text Field",
  "widgets.component": "Components",
  "widgets.layouts": "Layouts",
  "widgets.inputAdornments": "Input Adornments",
  "widgets.formattedInputs": "Formatted Inputs",
  "widgets.simpleSelect": "Simple Select",
  "widgets.nativeSelect": "Native Select",
  "widgets.MultiSelectList": "Multi Select List",
  "widgets.lineChart": "Line Chart",
  "widgets.barChart": "Bar Chart",
  "widgets.stackedBarChart": "Stacked Bar Chart",
  "widgets.lineBarAreaChart": "Line Bar Area Chart",
  "widgets.areaChart": "Area Chart",
  "widgets.stackedAreaChart": "Stacked Area Chart",
  "widgets.verticalChart": "Vertical Chart",
  "widgets.radarChart": "Radar Chart",
  "widgets.doughnut": "Doughnut",
  "widgets.polarChart": "Polar Chart",
  "widgets.pieChart": "Pie Chart",
  "widgets.bubbleChart": "Bubble Chart",
  "widgets.horizontalBar": "Horizontal Bar",
  "widgets.basicTable": "Basic Table",
  "widgets.contextualColoredTable": "Contextual Colored Table",
  "widgets.dataTable": "Data Table",
  "widgets.employeeList": "Employee List",
  "widgets.responsiveTable": "Responsive Table",
  "widgets.responsiveFlipTable": "Responsive Flip Table",
  "widgets.reactGridControlledStateMode": "React Grid Controlled State Mode",
  "widgets.productsReports": "Products Reports",
  "widgets.taskList": "Task List",
  "widgets.basicCalender": "Basic Calender",
  "widgets.culturesCalender": "Cultures Calender",
  "widgets.dragAndDropCalender": "Drag And Drop Calender",
  "widgets.selectableCalender": "Selectable Calender",
  "widgets.customRendering": "Custom Rendering",
  "widgets.customCalender": "Custom Calender",
  "widgets.searchMailList": "Search Mail List",
  "components.buyNow": "Buy Now",
  "components.choose": "Choose",
  "components.username": "Username",
  "components.passwords": "Passwords",
  "widgets.forgetPassword": "Forget Password",
  "components.signIn": "Sign In",
  "components.dontHaveAccountSignUp": "Dont Have Account SignUp",
  "components.enterUserName": "Enter User Name",
  "components.enterEmailAddress": "Enter Email Address",
  "components.confirmPasswords": "Confirm Passwords",
  "components.alreadyHavingAccountSignIn": "Already Having Account Sign In",
  "components.enterYourPassword": "Enter Your Password",
  "components.unlock": "Unlock",
  "components.enterPasswords": "Enter Passwords",
  "components.resetPassword": "Reset Password",
  "components.pageNotfound": "Page not Found",
  "components.goToHomePage": "Go To Home Page",
  "components.sorryServerGoesWrong": "Sorry Server Goes Wrong",
  "components.persistentDrawer": "Persistent Drawer",
  "components.withHtml": "With Html",
  "components.prompt": "Prompt",
  "components.withDescription": "With Description",
  "components.success": "Success",
  "components.passwordPrompt": "Password Prompt",
  "components.warning": "Warning",
  "components.customIcon": "Custom Icon",
  "components.customStyle": "Custom Style",
  "components.basic": "Basic",
  "components.submit": "Submit",
  "components.compose": "Compose",
  "components.sendMessage": "Send Message",
  "components.addNewTasks": "Add New Tasks",
  "components.addToCart": "Add To Cart",
  "components.payNow": "Pay Now",
  "components.print": "Print",
  "components.cart": "Cart",
  "components.viewCart": "View Cart",
  "components.checkout": "Checkout",
  "widgets.QuickLinks": "Quick Links",
  "widgets.upgrade": "upgrade",
  "widgets.app": "App",
  "widgets.addNew": "Add New",
  "widgets.orderDate": "Order Date",
  "widgets.status": "Status",
  "widgets.trackingNumber": "Tracking Number",
  "widgets.action": "Action",
  "widgets.designation": "Designation",
  "widgets.subject": "subject",
  "widgets.send": "Send",
  "widgets.saveAsDrafts": "Save As Drafts",
  "widgets.onlineSources": "Online Sources",
  "widgets.lastMonth": "Last Month",
  "widgets.widgets": "Widgets",
  "widgets.listing": "Listing",
  "widgets.paid": "Paid",
  "widgets.refunded": "Refunded",
  "widgets.done": "Done",
  "widgets.pending": "Pending",
  "widgets.cancelled": "Cancelled",
  "widgets.approve": "Approve",
  "widgets.following": "Following",
  "widgets.follow": "follow",
  "widgets.graphs&Charts": "Graphs & Charts",
  "widgets.open": "Open",
  "widgets.bounced": "Bounced",
  "widgets.spam": "Spam",
  "widgets.unset": "Unset",
  "widgets.bandwidthUse": "Bandwidth Use",
  "widgets.dataUse": "Data Use",
  "widgets.unsubscribe": "Unsubscribe",
  "widgets.profile": "Profile",
  "widgets.messages": "Messages",
  "widgets.support": "Support",
  "widgets.faq(s)": "Faq(s)",
  "widgets.upgradePlains": "Upgrade Plains",
  "widgets.logOut": "Log Out",
  "widgets.mail": "Mail",
  "widgets.adminTheme": "Admin Theme",
  "widgets.wordpressTheme": "Wordpress Theme",
  "widgets.addToCart": "Add To Cart",
  "widgets.plan": "Plan",
  "widgets.basic": "Basic",
  "widgets.pro": "Pro",
  "widgets.startToBasic": "Start To Basic",
  "widgets.upgradeToPro": "Upgrade To Pro",
  "widgets.upgradeToAdvance": "Upgrade To Advance",
  "widgets.comparePlans": "Compare Plans",
  "widgets.free": "Free",
  "widgets.frequentlyAskedQuestions": "Frequently Asked Questions",
  "widgets.searchIdeas": "Search Ideas",
  "widgets.startDate": "Start Date",
  "widgets.endDate": "End Date",
  "widgets.category": "Category",
  "widgets.apply": "Apply",
  "widgets.yesterday": "Yesterday",
  "widgets.totalOrders": "Total Orders",
  "widgets.totalVisitors": "Total Visitors",
  "widgets.typeYourQuestions": "Type Your Questions",
  "widgets.username": "Username",
  "widgets.password": "Password",
  "widgets.signIn": "Sign In",
  "widgets.enterYourPassword": "Enter Your Password",
  "widgets.alreadyHavingAccountLogin": "Account is already logged in",
  "widgets.composeMail": "Compose Mail",
  "widgets.issue": "Issue",
  "widgets.recentChat": "Recent Chat",
  "widgets.previousChat": "Previous Chat",
  "widgets.all": "All",
  "widgets.filters": "Filters",
  "widgets.deleted": "Deleted",
  "widgets.starred": "Starred",
  "widgets.frontend": "Frontend",
  "widgets.backend": "Backend",
  "widgets.api": "Api",
  "widgets.simpleAppBar": "Simple App Bar",
  "widgets.recents": "Recents",
  "widgets.cardLink": "Card Link",
  "widgets.anotherLink": "Another Link",
  "widgets.cardSubtitle": "card Subtitle",
  "widgets.confirmationDialogs": "Confirmation Dialogs",
  "widgets.deletableChip": "Deletable Chip",
  "widgets.customDeleteIconChip": "Custom Delete Icon Chip",
  "widgets.openAlertDialog": "Open Alert Dialog",
  "widgets.openResponsiveDialog": "Open Responsive Dialog",
  "widgets.openSimpleDialog": "Open Simple Dialog",
  "widgets.openFormDialog": "Open Form Dialog",
  "widgets.follower": "Follower",
  "widgets.important": "Important",
  "widgets.private": "Private",
  "widgets.openLeft": "Open Left",
  "widgets.openRight": "Open Right",
  "widgets.openTop": "Open Top",
  "widgets.openBottom": "Open Bottom",
  "widgets.selectTripDestination": "Select Trip Destination",
  "widgets.pinnedSubheaderList": "Pinned Subheader List",
  "widgets.singleLineItem": "Single Line Item",
  "widgets.optionA": "Option A",
  "widgets.optionB": "Option B",
  "widgets.optionC": "Option C",
  "widgets.optionM": "Option M",
  "widgets.optionN": "Option N",
  "widgets.optionO": "Option O",
  "widgets.customColor": "Custom Color",
  "widgets.centeredTabs": "Centered Tabs",
  "widgets.multipleTabs": "Multiple Tabs",
  "widgets.preventScrolledButtons": "Prevent Scrolled Buttons",
  "widgets.browse": "Browse",
  "widgets.formValidate": "Form Validate",
  "widgets.code": "Code",
  "widgets.company": "Company",
  "widgets.price": "Price",
  "widgets.change": "Change",
  "widgets.high": "High",
  "widgets.low": "Low",
  "widgets.volume": "Volume",
  "widgets.personalDetails": "Personal Details",
  "widgets.occupation": "Occupation",
  "widgets.companyName": "Company Name",
  "widgets.phoneNo": "Phone No",
  "widgets.updateProfile": "Update Profile",
  "widgets.reject": "Reject",
  "widgets.exportToExcel": "Export To Excel",
  "widgets.workWeek": "Work Week",
  "widgets.agenda": "Agenda",
  "widgets.conference": "Conference",
  "widgets.multilevel": "Multilevel",
  "widgets.dailySales": "Daily Sales",
  "widgets.today": "Today",
  "widgets.campaignPerformance": "Campaign Performance",
  "widgets.supportRequest": "Support Request",
  "widgets.usersList": "Users List ",
  "widgets.lastWeek": "Last Week",
  "themeOptions.sidebarOverlay": "Sidebar Overlay",
  "themeOptions.sidebarBackgroundImages": "Sidebar Background Images",
  "themeOptions.appSettings": "App Settings",
  "themeOptions.sidebarImage": "Sidebar Image",
  "themeOptions.miniSidebar": "Mini Sidebar",
  "themeOptions.boxLayout": "Box Layout",
  "themeOptions.rtlLayout": "Rtl Layout",
  "themeOptions.darkMode": "Dark Mode",
  "themeOptions.sidebarLight": "Light",
  "themeOptions.sidebarDark": "Dark",
  "button.cancel": "Cancel",
  "button.add": "Add",
  "button.update": "Update",
  "button.reply": "Reply",
  "button.delete": "Delete",
  "button.yes": "Yes",
  "button.viewAll": "View All",
  "button.like": "Like",
  "button.assignNow": "Assign Now",
  "button.seeInsights": "See Insights",
  "sidebar.dateTimePicker": "Date & Time Picker",
  "components.summary": "Summary",
  "hint.whatAreYouLookingFor": "What are You Looking For",
  "components.yesterday": "Yesterday",
  "components.last7Days": "Last 7 Days",
  "components.last1Month": "Last 1 Month",
  "components.last6Month": "Last 6 Month",
  "components.spaceUsed": "Space Used",
  "components.followers": "Follower",
  "components.trending": "Trending",
  "components.paid": "Paid",
  "components.refunded": "Refunded",
  "components.done": "Done",
  "components.pending": "Pending",
  "components.cancelled": "Cancelled",
  "components.approve": "Approve",
  "components.week": "Week",
  "components.month": "Month",
  "components.year": "Year",
  "components.today": "Today",
  "components.popularity": "Popularity",
  "components.email": "Email",
  "components.drafts": "Drafts",
  "components.sent": "Sent",
  "components.trash": "Trash",
  "components.all": "All",
  "components.do": "Do",
  "components.title": "Title",
  "components.projectName": "Project Name",
  "components.companyName": "Company Name",
  "components.openAlert": "Open Alert",
  "components.slideInAlertDialog": "Slide In Alert Dialog",
  "components.openFullScreenDialog": "Open Full Screen Dialogs",
  "components.basicChip": "Basic Chip",
  "components.clickableChip": "Clickable Chip",
  "components.left": "Left",
  "components.right": "Right",
  "components.expansionPanel1": "Expansion Panel 1",
  "components.expansionPanel2": "Expansion Panel 2",
  "components.generalSetting": "General Setting",
  "components.advancedSettings": "Advanced Settings",
  "components.firstName": "First Name",
  "components.lastName": "Last Name",
  "components.occupation": "Occupation",
  "components.phoneNo": "Phone No",
  "components.address": "Address",
  "components.city": "City",
  "components.state": "State",
  "components.zipCode": "Zip Code",
  "components.social Connection": "Social Connection",
  "widgets.buyMore": "Buy More",
  "widgets.trafficChannel": "Traffic Channel",
  "widgets.stockExchange": "Stock Exchange",
  "widgets.tweets": "Tweets",
  "widgets.ourLocations": "Our Locations",
  "widgets.sales": "Sales",
  "widgets.to": "To",
  "widgets.shipTo": "Ship To",
  "widgets.description": "Description",
  "widgets.unitPrice": "Unit Price",
  "widgets.total": "Total",
  "widgets.note": "Note",
  "widgets.chipWithAvatar": "Chip With Avatar",
  "widgets.chipWithTextAvatar": "Chip With Text Avatar",
  "widgets.chipWithIconAvatar": "Chip With Icon Avatar",
  "widgets.customClickableChip": "Custom Clickable Chip",
  "widgets.outlineChip": "Outline Chip",
  "widgets.disableChip": "Disable Chip",
  "widgets.alertDialog": "Alert Dialog",
  "widgets.animatedSlideDialogs": "Animated Slide Dialogs",
  "widgets.fullScreenDialogs": "Full Screen Dialogs",
  "widgets.formDialogs": "Form Dialogs",
  "widgets.simpleDialogs": "Simple Dialogs",
  "widgets.responsiveFullScreen": "Responsive Full Screen",
  "widgets.primary": "Primary",
  "widgets.social": "Social",
  "widgets.user": "User",
  "widgets.admin": "Admin",
  "widgets.permanentDrawer": "Permanent Drawer",
  "widgets.persistentDrawer": "Persistent Drawer",
  "widgets.switches": "Switches",
  "widgets.horizontalLinearAlternativeLabel":
    "Horizontal Linear Alternative Label",
  "widgets.horizontalNonLinearAlternativeLabel":
    "Horizontal Non Linear Alternative Label",
  "widgets.notifications": "Notifications",
  "widgets.basicAlert": "Basic Alert",
  "widgets.successAlert": "Success Alert",
  "widgets.warningAlert": "Warning Alert",
  "widgets.reactAutoSuggest": "React Auto Suggest",
  "widgets.components": "Components",
  "widgets.multiSelectList": "Multi Select List",
  "widgets.updateYourEmailAddress": "Update Your Email Address",
  "widgets.selectADefaultAddress": "Select A Default Address",
  "widgets.activity": "Activity",
  "widgets.basicCalendar": "Basic Calendar",
  "widgets.culturesCalendar": "Cultures Calendar",
  "widgets.dragAndDropCalendar": "Drag And Drop Calendar",
  "widgets.quillEditor": "Quill Editor",
  "widgets.reactDND": "React DND",
  "widgets.dragula": "Dragula",
  "button.acceptTerms": "Accept Terms",
  "button.reject": "Reject",
  "button.addNew": "Add New",
  "button.goToCampaign": "Go To Campaign",
  "button.viewProfile": "View Profile",
  "button.sendMessage": "Send Message",
  "button.saveNow": "Save Now",
  "button.pen": "Pen",
  "button.search": "Search",
  "button.downloadPdfReport": "Download Pdf Report",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.danger": "Danger",
  "button.info": "Info",
  "button.success": "Success",
  "button.warning": "Warning",
  "button.link": "Link",
  "button.smallButton": "Small Button",
  "button.largeButton": "Large Button",
  "button.blockLevelButton": "Block Level Button",
  "button.primaryButton": "Primary Button",
  "button.button": "Button",
  "button.save": "Save",
  "button.openMenu": "Open Menu",
  "button.openWithFadeTransition": "Open With Fade Transition",
  "button.openPopover": "Open Popover",
  "button.accept": "Accept",
  "button.click": "Click",
  "button.complete": "Complete",
  "button.back": "Back",
  "button.next": "Next",
  "button.completeStep": "Complete Step",
  "button.error": "Error",
  "button.writeNewMessage": "Write New Message",
  "button.saveChanges": "Save Changes",
  "button.addNewUser": "Add New User",
  "button.more": "More",
  "hint.searchMailList": "Search Mail List",
  "widgets.AcceptOrRejectWithin": "Accept or reject within",
  "widgets.quoteOfTheDay": "Quote Of The Day",
  "widgets.updated10Minago": "Updated 10 min ago",
  "widgets.personalSchedule": "Personal Schedule",
  "widgets.activeUsers": "Active Users",
  "widgets.totalRequest": "Total Request",
  "widgets.new": "New",
  "widgets.ShareWithFriends": "Share with friends!",
  "widgets.helpToShareText":
    "Help us spread the world by sharing our website with your friends and followers on social media!",
  "widgets.thisWeek": "This Week",
  "widgets.howWouldYouRateUs": "How would you rate us?",
  "widgets.booking": "Booking",
  "widgets.confirmed": "Confirmed",
  "widgets.monthly": "Monthly",
  "widgets.weekly": "Weekly",
  "widgets.target": "Target",
  "widgets.totalActiveUsers": "Total Active Users",
  "sidebar.user": "User",
  "sidebar.miscellaneous": "Miscellaneous",
  "sidebar.promo": "Promo",
  "themeOptions.themeColor": "Theme Color",
  "module.inbox": "Inbox",
  "module.drafts": "Drafts",
  "module.sent": "Sent",
  "module.trash": "Trash",
  "module.spam": "Spam",
  "module.frontend": "Frontend",
  "module.backend": "Backend",
  "module.api": "Api",
  "module.issue": "Issue",
  "components.emailPreferences": "Email Preferences",
  "components.myProfile": "My Profile",
  "sidebar.gettingStarted": "Getting Started",
  "widgets.deadline": "Deadline",
  "widgets.team": "Team",
  "widgets.projectManagement": "Project Management",
  "widgets.latestPost": "Latest Post",
  "widgets.projectTaskManagement": "Project Task Management",
  "widgets.selectProject": "Select Project",
  "widgets.activityBoard": "Activity Board",
  "widgets.checklist": "Checklist",
  "sidebar.shop": "Shop",
  "sidebar.cart": "Cart",
  "sidebar.checkout": "Checkout",
  "components.product": "Product",
  "components.quantity": "Quantity",
  "components.totalPrice": "Total Price",
  "components.removeProduct": "Remove Product",
  "components.mobileNumber": "Mobile Number",
  "components.address2Optional": "Address 2 (Optional)",
  "components.country": "Country",
  "components.zip": "Zip",
  "components.saveContinue": "Save & Continue",
  "components.placeOrder": "Place Order",
  "components.payment": "Payment",
  "components.billingAddress": "Billing Address",
  "components.ShippingAddressText":
    "Shipping address is the same as billing address.",
  "components.CartEmptyText": "Your Shopping Cart Is Empty!",
  "components.NoItemFound": "No Item Found",
  "components.goToShop": "Go To Shop",
  "components.cardNumber": "Card Number",
  "components.expiryDate": "Expiry Date",
  "components.cvv": "CVV",
  "components.nameOnCard": "Name On Card",
  "components.confirmPayment": "Confirm Payment",
  "sidebar.saas": "SAAS",
  "sidebar.multiLevel": "MultiLevel",
  "sidebar.level1": "Level 1",
  "sidebar.level2": "Level 2",
  "sidebar.boxed": "Boxed",
  //Warehouse receipt
  "warehouseReceipt.id": "ID",
  "warehouseReceipt.addHandlingUnit": "Add Handling Unit",
  "warehouseReceipt.handlingUnitsUpdated": "Handling Units Updated",
  "warehouseReceipt.updateHandlingUnit": "Update Handling Unit",
  "warehouseReceipt.huNotFound": "Handling Unit Not Found",
  "warehouseReceipt.unableToGetHU": "Unable to get Handling Units",
  "warehouseReceipt.unableToAddHU": "Cannot add Handling Unit",
  "warehouseReceipt.vendor": "Vendor",
  "warehouseReceipt.purchaseOrder": "Purchase Order",
  "warehouseReceipt.invoiceNumber": "Invoice #",
  "warehouseReceipt.serviceType": "Service Type",
  "warehouseReceipt.created": "Created",
  "warehouseReceipt.finalized": "Finalized",
  "warehouseReceipt.notFinalizedException": "Not Finalized",
  "warehouseReceipt.exceptionException": "Exception",
  "warehouseReceipt.missingDocumentationException": "Missing Documentation",
  "warehouseReceipt.okException": "Ok",
  "warehouseReceipt.noWarehouseReceipts": "No warehouse receipts",
  "warehouseReceipt.status": "Status",
  "warehouseReceipt.noPieces": "No Pieces",
  "warehouseReceipt.addNew": "Add New",
  "warehouseReceipt.issuesResolved": "Issues Resolved",
  //Warehouse Details
  "whsReceiptDetails.details": "Details",
  "whsReceiptDetails.none": "NONE",
  "whsReceiptDetails.number": "Number",
  "whsReceiptDetails.adhoc": "Adhoc",
  "whsReceiptDetails.cancel": "Cancel",
  "whsReceiptDetails.warehouse": "Warehouse",
  "whsReceiptDetails.created": "Created",
  "whsReceiptDetails.customer": "Customer",
  "whsReceiptDetails.shipper": "Shipper",
  "whsReceiptDetails.inboundCarrier": "Inbound Carrier",
  "whsReceiptDetails.invoiceDate": "Invoice Date",
  "whsReceiptDetails.invoiceNumber": "Invoice Number",
  "whsReceiptDetails.blNumber": "B/L Number",
  "whsReceiptDetails.stated": "Stated",
  "whsReceiptDetails.actual": "Actual",
  "whsReceiptDetails.remarks": "Remarks",
  "whsReceiptDetails.palletCount": "Pallet Count",
  "whsReceiptDetails.cartonCount": "Carton Count",
  "whsReceiptDetails.actualCartonCount": "Actual Carton Count",
  "whsReceiptDetails.actualPalletCount": "Actual Pallet Count",
  "whsReceiptDetails.statedCartonCount": "Stated Carton Count",
  "whsReceiptDetails.statedPalletCount": "Stated Pallet Count",
  "whsReceiptDetails.grossKgs": "Gross (KGS)",
  "whsReceiptDetails.grossLbs": "Gross (LBS)",
  "whsReceiptDetails.value": "Value (USD)",
  "whsReceiptDetails.salesOrder": "Sales Order",
  "whsReceiptDetails.shipSet": "Ship Set",
  "whsReceiptDetails.finalizedBy": "Finalized By",
  "whsReceiptDetails.finalizedOn": "Finalized On",
  "whsReceiptDetails.finalize": "Finalize",
  "whsReceiptDetails.documents": "Document Remarks",
  "whsReceiptDetails.unusedPouch": "Unused Pouch",
  "whsReceiptDetails.temperedPouch": "Tempered Pouch",
  "whsReceiptDetails.missingSignature": "Invoice Missing Signature",
  "whsReceiptDetails.missingPouch": "Missing Pouch",
  "whsReceiptDetails.exception": "Exception",
  "whsReceiptDetails.docIssuesReslv": "Documentation issues resolved?",
  "whsReceiptDetails.warehouseRM":
    "Warehouse receipt missing items from PL (shortage)",
  "whsReceiptDetails.missingDocuments": "Missing Documents",
  "whsReceiptDetails.packingList": "Packing List",
  "whsReceiptDetails.sli": "SLI",
  "whsReceiptDetails.pieces": "Pieces",
  "whsReceiptDetails.pieceNumber": "Piece Number",
  "whsReceiptDetails.pieceID": "Piece ID",
  "whsReceiptDetails.pieceType": "Piece Type",
  "whsReceiptDetails.length": "Length (in)",
  "whsReceiptDetails.width": "Width (in)",
  "whsReceiptDetails.height": "Height (in)",
  "whsReceiptDetails.trackingNumbers": "Tracking",
  "whsReceiptDetails.shipped": "Shipped",
  "whsReceiptDetails.received": "Received",
  "whsReceiptDetails.eta": "ETA",
  "whsReceiptDetails.files": "Files",
  "whsReceiptDetails.name": "Name",
  "whsReceiptDetails.size": "Size",
  "whsReceiptDetails.download": "Download",
  "whsReceiptDetails.emptyFileList": "No Files!",
  "whsReceiptDetails.save": "Save",
  "whsReceiptDetails.edit": "edit",
  "whsReceiptDetails.lin": "LIN",
  "whsReceiptDetails.partNumber": "Part Number",
  "whsReceiptDetails.overage": "Overage",
  "whsReceiptDetails.shortage": "Shortage",
  "whsReceiptDetails.damaged": "Damaged",
  "whsReceiptDetails.carton": "Carton",
  "whsReceiptDetails.pallet": "Pallet",
  "whsReceiptDetails.pieceCount": "Piece Count",
  "whsReceiptDetails.emptyTracking": "No Tracking Available",
  "whsReceiptDetails.carrier": "Carrier",
  "whsReceiptDetails.emptyCosts": "N/A",
  "whsReceiptDetails.total": "Total",
  "whsReceiptDetails.notFinalized": "Not Finalized",
  "whsReceiptDetails.customerPO": "*Customer PO",
  "whsReceiptDetails.costs": "Costs",
  "whsReceiptDetails.costItemCode": "Code",
  "whsReceiptDetails.costItemDescription": "Item",
  "whsReceiptDetails.description": "Description",
  "whsReceiptDetails.ok": "OK",
  //Costs
  "cost.sell": "Sell",
  "cost.cost": "Cost",
  "cost.displayName": "Name",
  "cost.description": "Description",
  //Shipment Labels
  "shipment.name": "Shipment",
  "shipment.copyToClipboard": "Copy Shipment Details",
  "shipment.cost": "Apply Costs",
  "shipment.appliedCosts": "Applied all automated costs",
  "shipment.redyByDate": "Ready By Date",
  "shipment.shipmentName": "Shipment Name",
  "shipment.adhoc": "Adhoc",
  "shipment.warehouse": "Warehouse",
  "shipment.forwarded": "Forwarded",
  "shipment.customer": "Customer",
  "shipment.subtotal": "Subtotal (USD)",
  "shipment.total": "Total",
  "shipment.created": "Shipment Created",
  "shipment.finalize": "Finalize",
  "shipment.unfinalize": "Unfinalize",
  "shipment.finalized": "Finalized",
  "shipment.unfinalized": "Unfinalized",
  "shipment.itemAdded": "Item added to Shipment",
  "shipment.unableToAddItem": "Could not add item to Shipment",
  "shipment.itemAdjusted": "Shipment Item Adjusted",
  "shipment.unableToAdjustItem": "Unable to Update Shipment Item",
  "shipment.picked": "Picked",
  "shipment.packaged": "Packaged",
  "shipment.exported": "Exported",
  "shipment.received": "Received",
  "shipment.cartonCount": "Carton Count",
  "shipment.cartonsInBundles": "Carton in Bundles",
  "shipment.bundleCount": "Bundle Count",
  "shipment.physicalCartonCount": "Physical Carton Count",
  "shipment.pieceCount": "Piece Count",
  "shipment.pieceHeight": "Piece Height (in)",
  "shipment.grossKgs": "Gross (Kgs)",
  "shipment.netKgs": "Net (Kgs)",
  "shipment.grossLbs": "Gross (Lbs)",
  "shipment.dimAirKgs": "Dimensional Weight Air (Kgs)",
  "shipment.dimAirLbs": "Dimensional Weight Air (Lbs)",
  "shipment.dimGrndDomLbs": "Dimensional Weight Ground (Lbs)",
  "shipment.shipTo": "Ship To",
  "shipment.billTo": "Bill To",
  "shipment.payTo": "Pay To",
  "shipment.ultimateConsignee": "Ultimate Consignee",
  "shipment.outBoundCarrier": "Outbound Carrier",
  "shipment.addressOutboundCarrier": "Outbound Carrier Address",
  "shipment.grossKgsLbs": "Gross (Kgs/Lbs)",
  "shipment.subtotalUSD": "Subtotal (USD)",
  "shipment.totalUSD": "Total (USD)",
  "shipment.remarks": "Remarks",
  "shipment.notes": "notes",
  "shipment.commodity": "Commodity",
  "shipment.cuFt": "Cu. Ft.",
  "shipment.queue": "Queue",
  "shipment.queued": "Queued",
  "shipment.pieces": "Pieces",
  "shipment.files": "Files",
  "shipment.size": "Size",
  "shipment.status": "Status",
  "shipment.pieceNumber": "Piece #",
  "shipment.download": "Downloads",
  "shipment.densityPcf": "Density (PCF)",
  "shipment.noShipments": "No shipments",
  "shipment.serviceItems": "Service Items",
  "shipment.outboundCarrier": "Outbound Carrier",
  "shipment.new": "New Shipment",
  "shipment.warehouseReceipt": "Warehouse Receipt",
  "shipment.purchaseOrder": "Purchase Order",
  "shipment.salesOrder": "Sales Order",
  "shipment.line": "Line",
  "shipment.part": "Part",
  "shipment.invoiceNumber": "Invoice Number",
  "shipment.shpQtyAvailable": "Qty Available",
  "shipment.qtyPendingToReceive": "Qty Pending To Receive",
  "shipment.qtyQueued": "Qty Queued",
  "shipment.conditionCode": "Condition Code",
  "shipment.partModel": "Part Model",
  "shipment.onHandDate": "On-Hand Date",
  "shipment.expirationDate": "Expiration Date",
  "shipment.unitPrice": "Unit Price",
  "shipment.customUnitPrice": "Custom Unit Price",
  "shipment.qtyReceived": "Qty Received",
  "shipment.shpQtyToAdd": "Qty To Add",
  "shipment.addLargerThanAvailable": "Qty to Add is larger than available",
  "shipment.invalidQtyInput": "Invalid Qty to Add",
  "shipment.countryDestination": "Destination Country",
  "shipment.addItems": "Add Items",
  "shipment.saveShipmentBeforeItem": "Save shipment before adding items",
  "shipment.shpQtyOrdered": "Qty Ordered",
  "shipment.shpQtyPicked": "Qty Picked",
  "shipment.shpQtyScanned": "Qty Scanned",
  "shipment.shpQtyToBeReceived": "Qty to be received",
  "shipment.shpQtyOverage": "Qty Overage",
  "shipment.shpQtyReworked": "Qty Reworked",
  "shipment.shpQtyInStock": "Qty In Stock",
  "shipment.duplicateShipment": "Shipment Already Exists",
  "shipment.shpQtyOrderedForShipment": "Shipment Qty Ordered",
  "shipment.shipped": "Qty Shipped",
  "shipment.vendor": "Vendor",
  "shipment.tracking": "Tracker",
  "shipment.save": "Shipment Saved",
  "shipment.allItemsAdded": "All items added",
  "shipment.missingBillingProfile":
    "Click to setup this company's billing information",
  "shipment.addPiece": "Add a Shipment Piece",
  "shipment.updatePiece": "Update Shipment Piece",
  "shipment.pieceType": "Piece Type",
  "shipment.palletType": "Pallet Type",
  "shipment.isWoodPackaging": "Wood Packaged",
  "shipment.hasLithium": "Lithium",
  "shipment.hazmat": "Hazard Material",
  "shipment.isLooseCartons": "Loose Cartons",
  "shipment.pieceDimensions": "Shipment Piece Dimensions (in)",
  "shipment.pieceLength": "Length (in)",
  "shipment.pieceWidth": "Width (in)",
  "shipment.skidRelocationPrompt": "Enter a SKID to relocate items to:",
  "shipment.skidRelocation": "SKID",
  "shipment.qtyToPrintPrompt": "How many labels to print?",
  "shipment.qtyToPrint": "Number of Labels",
  "shipment.partiesToTransaction": "Parties to Transaction",
  "shipment.modeOfTransport": "Mode of Transport",
  "shipment.carrierIdentificationCode": "Carrier Identification Code",
  "shipment.exportingCarrier": "Exporting Carrier",
  "shipment.portOfExport": "Port of Export",
  "shipment.transportationReferenceNumber": "Transportation Reference Number",
  "shipment.portOfUnloading": "Port of Unloading",
  "shipment.pointOfOrigin": "Point of Origin",
  "shipment.isContainerized": "Containerized",
  "shipment.isHazMat": "Hazardous Material",
  "shipment.isRoutedExportTxn": "Routed Export Transaction",
  "shipment.declaredCustomsValue": "Customs Value",
  "shipment.declaredCarriageValue": "Carriage Value",
  "shipment.ITN": "ITN Number",
  "shipment.shipperRequestsInsurance": "Insurance",
  "shipment.documentsEnclosed": "Documents Enclosed",
  "shipment.inlandPickup": "Inland Pickup",
  "shipment.COMINV": "Commercial Invoice",
  "shipment.PACK": "Packing List",
  "shipment.AIR": "Air",
  "shipment.COD": "C.O.D.",
  "shipment.OCEAN": "Ocean",
  "shipment.PREPAID": "Prepaid",
  "shipment.DIRECT": "Direct",
  "shipment.COLLECT": "Collect",
  "shipment.CONSOLIDATE": "Consolidate",
  "shipment.holds": "Holds",
  "shipment.cutoff": "Cutoff Time",
  "shipment.requested": "Requested By",
  "shipment.cancelled": "Cancelled On",

  //Shipment builder selector
  "shipmentBuilderSelector.partNumber": "PART NUMBER",
  "shipmentBuilderSelector.warehouseReceipt": "WAREHOUSE RECEIPT",
  "shipmentBuilderSelector.purchaseOrder": "PURCHASE ORDER",
  // Shipment Progress
  "shipmentProgress.submit": "Submit Timestamp",
  "shipmentProgress.remove": "Remove Timestamp",
  "shipmentProgress.Picked": "Update Picked Timestamp",
  "shipmentProgress.PickedTimestamp": "Picked Timestamp",
  "shipmentProgress.Packaged": "Update Packaged Timestamp",
  "shipmentProgress.PackagedTimestamp": "Packaged Timestamp",
  "shipmentProgress.Forwarded": "Update Forwarded Timestamp",
  "shipmentProgress.ForwardedTimestamp": "Forwarded Timestamp",
  "shipmentProgress.Exported": "Update Exported Timestamp",
  "shipmentProgress.ExportedTimestamp": "Exported Timestamp",
  "shipmentProgress.Received": "Update Received Timestamp",
  "shipmentProgress.ReceivedTimestamp": "Received Timestamp",
  // Shipment Holds
  "shipmentHold.createHold": "Create a Hold",
  "shipmentHold.holdType": "Type of Hold",
  "shipmentHold.active": "Active",
  "shipmentHold.description": "Hold Reason",
  "shipmentHold.hold": "Shipment Hold",
  "shipmentHold.updateHold": "Update Hold",
  "shipmentHold.noHolds": "No Holds",
  "shipmentHold.addHold": "Add A Hold",
  //Queue Labels
  "queue.salesOrder": "Sales Order",
  "queue.shipSet": "Ship Set",
  "queue.customerPO": "Customer PO",
  "queue.lin": "LIN",
  "queue.part": "Part",
  "queue.customDescription": "Custom Description",
  "queue.ordered": "Ordered",
  "queue.remaining": "Remaining",
  "queue.customExtended": "Custom Extended Price",
  "queue.scheduleBNumber": "Schedule B Number",
  "queue.eccn": "ECCN",
  "queue.extendedPrice": "Extended Price (USD)",
  //Pieces Label
  "pieces.pieceType": "Piece Type",
  "pieces.pieceNumber": "Piece Number",
  "pieces.cartonCount": "Carton Count",
  "pieces.grossKgs": "Gross (Kgs)",
  "pieces.grossLbs": "Gross (Lbs)",
  "pieces.lengthIn": "Length (in)",
  "pieces.widthIn": "Width (in)",
  "pieces.heightIn": "Height (in)",
  "pieces.lengthCM": "Length (cm)",
  "pieces.widthCM": "Width (cm)",
  "pieces.heightCM": "Height (cm)",
  "pieces.scheduleBNumber": "Schedule B Number",
  "pieces.warehouseReceipt": "Warehouse Receipt",
  "pieces.FLID": "FLID",
  "pieces.majorQty": "Quantity",
  "pieces.partNumber": "Part #",
  "pieces.dimensionsIntl": "Dimensions (cm³)",
  "pieces.dimensionsUS": "Dimensions (in³)",
  "pieces.weightIntl": "Weight (kgs)",
  "pieces.weightLbs": "Weight (lbs)",
  "pieces.subcarton": "Sub Carton",
  "pieces.hazmat": "Hazard Material",
  "pieces.woodPackaging": "Wood Packaging",
  "pieces.lithium": "Lithium",

  //Files
  "file.name": "Name",
  "file.created": "Uploaded On",
  "file.size": "Size",
  "file.download": "Download",
  "file.downloadZip": "Download All",
  "file.empty": "Empty",
  "file.thumb": "Preview",
  "file.downloadStart": "File download starting...",
  "general.success": "Success",
  "file.clickHere": "Click here to download",
  "file.downloadAction": "Download Files",
  //Purchase Order
  "purchaseOrder.identifier": "Customer PO",
  "purchaseOrder.currency": "Currency",
  "purchaseOrder.status": "Status",
  "purchaseOrder.endUser": "End User",
  "purchaseOrder.created": "Created",
  "purchaseOrder.customer": "Customer",
  "purchaseOrder.submitted": "Submitted",
  "purchaseOrder.requestedShipDate": "Requested Ship Date",
  "purchaseOrder.salesOrder": "Sales Order",
  "purchaseOrder.vendorOrder": "Vendor Order",
  "purchaseOrder.finalizedBy": "Finalized By",
  "purchaseOrder.vendor": "Vendor",
  "purchaseOrder.items": "Items",
  "purchaseOrder.finalizedOn": "Finalized On",
  "purchaseOrder.files": "Files",
  "purchaseOrder.subTotal": "Subtotal (USD)",
  "purchaseOrder.notes": "notes",
  "purchaseOrder.remarks": "Remarks",
  "purchaseOrder.name": "Customer PO",
  "purchaseOrder.new": "Create Purchase Order",
  "sidebar.noPurchaseOrders": "No purchase orders",
  "purchaseOrder.subtotal": "Purchase Order Subtotal",
  "purchaseOrder.addressEndUser": "End User Address",
  "purchaseOrder.addressShipper": "Shipper Address",
  "purchaseOrder.addressShipTo": "Ship To Address",
  "purchaseOrder.addressBillTo": "Bill To Address",
  "purchaseOrder.selectWarehouse": "View Purchase Order Item quantities for:",
  //Purchase Order Items
  "purchaseOrderItem.item": "Purchase Order Item",
  "purchaseOrderItem.lineItemNumber": "LN",
  "purchaseOrderItem.breakdown": "Breakdown",
  "purchaseOrderItem.partNumber": "Part #",
  "purchaseOrderItem.description": "Description",
  "purchaseOrderItem.retailPrice": "Retail Price",
  "purchaseOrderItem.discount": "Discount Rate",
  "purchaseOrderItem.unitPrice": "Unit Price",
  "purchaseOrderItem.qtyOrdered": "Ordered",
  "purchaseOrderItem.extendedPrice": "Extended Price",
  "purchaseOrderItem.qtyReceived": "Received",
  "purchaseOrderItem.qtyToBeReceived": "To Be Recd.",
  "purchaseOrderItem.qtyInStock": "In Stock",
  "purchaseOrderItem.qtyQueued": "Queued",
  "purchaseOrderItem.available": "Available",
  "purchaseOrderItem.addItem": "Add Item",
  "purchaseOrderItem.updateItem": "Update Item",
  "purchaseOrderItem.qtyReworked": "Reworked",
  "purchaseOrderItem.shipped": "Shipped",
  "purchaseOrderItem.overage": "Overage",
  "purchaseOrderItem.noItems": "No items",
  "purchaseOrderItem.part": "Part",
  "purchaseOrderItem.partIntangible": "Intangible",
  "purchaseOrderItem.isReceivable": "Receivable",
  "purchaseOrderItem.hasSerials": "Has Serials",
  "purchaseOrderItem.isReserved": "Reserved",
  "purchaseOrderItem.partInformation": "Part Information",
  "purchaseOrderItem.shipSet": "Ship Set",
  // Transactions
  "transaction.customer": "Customer",
  "transaction.chargeCount": "Charges",
  "transaction.findChargeCode": "Type Charge Code",
  "transaction.total": "Total ($ USD)",
  "transaction.deleted": "Deleted",
  "transaction.transactionType": "Transaction Type",
  "transaction.details": "Transaction Details",
  "transaction.openCharges": "Open Charges",
  "sidebar.transactions": "Transactions",
  "transaction.noTransactions": "No Transactions",
  "transaction.addNew": "New Transaction",
  "transaction.reference": "Reference",
  "transaction.chargeCode": "Charge Code",
  "transaction.description": "Charge Description",
  "transaction.status": "Status",
  "transaction.posted": "Posted",
  "transaction.open": "Open",
  "transaction.cost": "Cost ($ USD)",
  "transaction.sell": "Sell ($ USD)",
  "transaction.quantity": "QTY",
  "transaction.finalize": "Finalize",
  "transaction.isFinalized": "Finalized",
  "transaction.id": "ID",
  "transaction.applyToAddress": "Apply To Address",
  "transaction.pendingCharges": "Pending Charges",
  "transaction.updateCharge": "Update Charge",
  "transaction.viewCharge": "View Charge",
  "transaction.chargeReference": "Charge Reference",
  "transaction.totalSell": "Sell Total ($ USD)",
  "transaction.totalCost": "Cost Total ($ USD)",
  "transaction.subtotalSell": "Sell Subtotal ($ USD)",
  "transaction.subtotalCost": "Cost Subtotal ($ USD)",
  "transaction.profit": "Profit ($ USD)",
  "transaction.grossProfit": "Gross Profit ($ USD)",
  "transaction.applyCharge": "Apply Charge",
  "transaction.addApplicableCharges": "Add Applicable Charges",
  "transaction.addCharge": "Add a Charge",
  "transaction.remove": "Remove Charge",
  //stock
  "stock.warehouse": "Warehouse",
  "stock.vendor": "Vendor",
  "stock.venderOrder": "Vendor Order",
  "stock.customerPO": "Customer PO",
  "stock.vendorOrderID": "Vendor Order ID",
  "stock.salesOrderID": "Sales Order ID",
  "stock.lin": "LIN",
  "stock.part": "Part #",
  "stock.qtyInStock": "Qty In Stock",
  "stock.extendedPriceInStock": "Extended Price in Stock",
  "stock.qtyAvailable": "Qty Available",
  "stock.warehouseReceipt": "Warehouse Receipt",
  "stock.onHandDate": "On Hand Date",
  "stock.conditionCode": "Condition Code",
  "sidebar.noStock": "No Stock",
  "stock.STOCK_NO_PO.warning":
    "Unable to retrieve: Customer PO, Vendor Order, Sales Order ID",
  "stock.STOCK_NO_WR.warning": "Unable to retrieve: Warehouse Receipt",
  "stock.FALLBACK_DATA.warning":
    "Unable to retrieve: Warehouse Receipt, Customer PO, Vendor Order, Sales Order ID",
  "stock.qtyOrdered": "Qty Ordered",
  "stock.qtyReceived": "Qty Received",
  "stock.qtyQueued": "Qty Queued",
  "stock.qtyShipped": "Qty Shipped",
  //table preferences
  "tablePreferences.displayPreferences": "Display Preferences",
  "tablePreferences.numberOfRows": "Number of Rows to Display",
  "tablePreferences.columnSelectionOrdering": "Column Selection and Ordering",
  "tablePreferences.addOrRemoveCol":
    "Add or Remove Columns by selecting, then use the buttons to move one or all columns. Change order by selecting a Column label and using the Up and Down buttons.",
  "tablePreferences.leftLabel": "All Columns",
  "tablePreferences.rightLabel": "Included Columns",
  "tablePreferences.sortingPreferences": "Sorting Preferences",
  "tablePreferences.sortingPreferencesInfo":
    "Set your sorting preference by selecting a column to sort by and its sorting order",
  "tablePreferences.cancel": "Cancel",
  "tablePreferences.save": "Save",
  "tablePreferences.editTable": "Edit Table",
  "tablePreferences.sortBy": "Sort By",
  "tablePreferences.sortOrder": "Sort Order",
  "tablePreferences.ascending": "Ascending",
  "tablePreferences.descending": "Descending",
  "tablePreferences.search": "Search...",
  "tablePreferences.selectAtLeastOneColumn":
    "At least one column must be included!",
  "tablePreferences.switchToLandscape":
    "Switch to landscape to view preferences",
  //about us
  "aboutUs.whoWeAreTitle": "WHO WE ARE",
  "aboutUs.whoWeAreMsg":
    "Rhenus Freight Logistics is a privately owned, premier international freight forwarder and logistics-solutions provider located in Miami, Florida. With our strategic-partnership network, we provide worldwide coverage for our forwarding and logistics customers. Our facility is designed to offer exceptional logistics services to the world’s leading high-technology manufacturers, distributors and integrators, whom we have serviced with great success since 2001.",
  "aboutUs.environmentalResTitle": "ENVIRONMENTAL RESPONSIBILITY",
  "aboutUs.environmentalResMesg":
    "As a committed member of the global environmental community, Rhenus Freight Logistics is dedicated to limiting CO₂ emissions and itself operates under environmental standards. Within its warehouse, Rhenus Freight Logistics utilizes energy-efficient lighting and HVAC systems and encourages environmental conscientiousness from its employees and contractors. Rhenus Freight Logistics’ start-of-the-art warehousing facility in Miami, Florida is built partially from green construction materials, and is an energy-efficient building. Rhenus Freight Logistics’ environmental responsibility includes working with industry partners, employees and customers to help ensure sustainable operations throughout the supply chain.",
  "aboutUs.highlightYear": "85 years of collective industry experience",
  "aboutUs.highlightExperience":
    "Specialty in high-value, industrial and consumer electronics plus experience in a wide variety of customer verticals",
  "aboutUs.highlightAccuracy": "99.9% Shipping Accuracy",
  "aboutUs.highlightRetention": "95% Customer Retention Rate",
  "aboutUs.highlightLeadLength":
    "7.5 Years Average Length of Customer Relationship",
  //User Profile
  "userProfile.addressDeleted": "Address Deleted!",
  "userProfile.addNewAddress": "Add New Address",
  "userProfile.profileUpdated": "Profile Updated Successfully!",
  "userProfile.oldPassword": "Old Password",
  "userProfile.newPassword": "New Password",
  "userProfile.confirmPassword": "Confirm Password",
  "userProfile.update": "Update",
  "userProfile.invalidPasswordFields": "Password fields invalid",
  "userProfile.passwordDontMatch":
    "New Password and Confirm Password don't match",
  "userProfile.changePassword": "Change Password",
  "userProfile.oldPasswordError": "Invalid old password",
  //export
  "export.exportPreferences": "Export Options",
  "export.columnSelectionOrdering": "Columns",
  "export.selectOrder": "Select and Order Columns to Export",
  "export.export": "Export",
  "export.cancel": "Cancel",
  "export.table": "Export Table",
  "export.exportingFile": "Exporting file...",
  "export.sortingPreferencesInfo":
    "Select your sorting preference by selecting a column to sort by and its sorting order",
  //report
  "report.simpleStockSummary": "Simple Stock Summary",
  "report.simpleStockSummaryDesc":
    "Part number, total quantity available and physical warehousing facility.",
  "report.stockSummary": "Stock Summary",
  "report.stockSummaryDesc": "All items currently in stock.",
  "report.stockDetail": "Stock Detail",
  "report.stockDetailDesc":
    "All items currently in stock; item level. Includes serial numbers.",
  "report.outBoundDetail": "Outbound Detail",
  "report.outBoundDetailDesc":
    "All shipped items, item level, in transit from warehousing facilities to destination. Includes serial numbers.",
  "report.dailyReceivedDetail": "Daily Received Detail",
  "report.dailyReceivedDetailDesc":
    "All items received for a given day; carton level.",
  "report.dailyShippedDetail": "Daily Shipped Detail",
  "report.dailyShippedDetailDesc":
    "All items shipped from warehousing facilities, as of the date and time specified. Defaults to user's local current date and time. Includes serial numbers.",
  "report.purchaseOrderDetail": "Purchase Order Detail",
  "report.purchaseOrderDetailDesc":
    "All purchase order items , item level. Includes vendor-specific information such as current promise dates, and vendor invoice numbers(when available). Also includes all quantity calculations e.g quantities on hand, shipped, to be received etc.",
  "report.shipmentDetail": "Shipment Detail",
  "report.shipmentDetailDesc":
    "All shipment items, item level. Includes serial numbers.",
  "report.shipmentStatusSummary": "Shipment Status Summary",
  "report.shipmentStatusSummaryDesc":
    "All finalized shipments grouped by status (Queued, Picked, Packaged, or Forwarded/Outbound now). Received shipments are not shown.",
  "report.run": "Run",
  "report.scheduledReports": "Scheduled Reports",
  "report.title": "Reports",
  "report.legacyReports": "Legacy Reports",
  "report.running": "Running",
  "report.report": "Report",
  "report.successRunning": "Report Ran Successfully",
  "report.noScheduledReports": "No Scheduled Reports",
  //warehouse receipt creation
  "whsReceipt.na": "NA",
  "whsReceipt.itemscoo": "Items Country of Origin",
  "whsReceipt.status": "Status",
  "whsReceipt.commercialInvoice": "*Commercial Invoice",
  "whsReceipt.invoiceNumber": "Invoice Number",
  "whsReceipt.values": "Values",
  "whsReceipt.date": "Date",
  "whsReceipt.issues": "Issues",
  "whsReceipt.salesOrder": "Sales Order",
  "whsReceipt.fastlaneLookup": "Fastlane Lookup",
  "whsReceipt.vendorOrder": "Vendor Order",
  "whsReceipt.newWarehouseReceipt": "New Warehouse Receipt",
  "whsReceipt.new": "New",
  "whsReceipt.missingCommercialInvoice": "Missing Commercial Invoice",
  "whsReceipt.packingList": "Missing Packing List",
  "whsReceipt.sli": "Missing SLI",
  "whsReceipt.temperedPouch": "Tampered Pouch",
  "whsReceipt.missingSignature": "Invoice Missing Signature",
  "whsReceipt.missingPouch": "Missing Pouch",
  "whsReceipt.missingItemsP1": "Missing items from",
  "whsReceipt.missingItemsP2": "packing list (shortage)",
  "whsReceipt.addPiece": "Add Piece",
  "whsReceipt.warehouse": "Warehouse",
  "whsReceipt.remarks": "Remarks",
  "whsReceipt.customer": "*Customer",
  "whsReceipt.customerPlaceholder": "Select Customer",
  "whsReceipt.shipper": "*Shipper",
  "whsReceipt.shipperPlaceholder": "Select Shipper",
  "whsReceipt.carrier": "*Carrier",
  "whsReceipt.carrierPlaceholder": "Select Carrier",
  "whsReceipt.palletType": "Pallet Type",
  "whsReceipt.pieceType": "Piece Type",
  "whsReceipt.pieceCount": "Piece Count",
  "whsReceipt.pieceDetails": "Piece Details",
  "whsReceipt.cartonCount": "Carton Count Per Piece",
  "whsReceipt.ultimateConsignee": "Ultimate Consignee",
  "whsReceipt.consigneeLookup": "Consignee Lookup",
  "whsReceipt.condition": "Condition",
  "whsReceipt.battery": "Battery",
  "whsReceipt.hazmat": "Hazmat",
  "whsReceipt.pieceDimensions": "Piece Dimensions",
  "whsReceipt.pieceLength": "Length (in)",
  "whsReceipt.pieceWidth": "Width (in)",
  "whsReceipt.pieceHeight": "Height (in)",
  "whsReceipt.identifier": "Identifier",
  "whsReceipt.grossKgs": "Gross (KGS)",
  "whsReceipt.items": "Items",
  "whsReceipt.partNumber": "Part Number",
  "whsReceipt.quantityEach": "Qty Each",
  "whsReceipt.coo": "COO",
  "whsReceipt.serials": "Serials",
  "whsReceipt.wood": "Wood",
  "whsReceipt.addItems": "Add Items",
  "whsReceipt.addItem": "Add Item",
  "whsReceipt.noItems": "No Items",
  "whsReceipt.dimensions": "Dimensions",
  "whsReceipt.nfw": "NFW",
  "whsReceipt.noPieces": "Add Pieces",
  "whsReceipt.updatePiece": "Update Piece",
  "whsReceipt.selectCustomerFirst": "select customer first",
  "whsReceipt.hasWood": "Contains Wood",
  "whsReceipt.print": "Print",
  "whsReceipt.addNew": "Add New",
  "whsReceipt.vendorCustomerError": "Select Shipper and Customer",
  "whsReceipt.containerNumber": "Container Number",
  "whsReceipt.addTracking": "Add Tracking",
  "whsReceipt.updateTracking": "Update Tracking",
  "whsReceipt.exceptionsResolved": "Issues Resolved",
  //User Management
  "userManagement.userCreated": "User Created",
  "userManagement.title": "Company Title",
  "userManagement.noDLs": `Unable to get Distribution Lists for selected companies. Add
  directly to a Company's Distribution List through the Company
  Tab.`,
  "userManagement.companyGroup": "Company Group",
  "userManagement.createCompanyGroup": "Create Company Group",
  "userManagement.personType": "Type of Contact",
  "userManagement.addUser": "Add User",
  "userManagement.remove": "Remove",
  "userManagement.deleteUser": "Delete User",
  "userManagement.userDetails": "Details",
  "userManagement.users": "Users",
  "userManagement.permissions": "Permission Groups",
  "userManagement.accessGroups": "Access Groups",
  "userManagement.firstName": "First Name",
  "userManagement.lastName": "Last Name",
  "userManagement.email": "Email",
  "userManagement.preferredUsername": "Preferred Username",
  "userManagement.phone": "Phone",
  "userManagement.password": "Password",
  "userManagement.confirmPassword": "Confirm Password",
  "userManagement.accountStatus": "Status",
  "userManagement.invalidFields": "Please correct invalid fields",
  "userManagement.noUsers": "No users",
  "userManagement.userDeleteFail": "Failed to delete user",
  "userManagement.companies": "Companies",
  "userManagement.resetPasswordConfirmation":
    "Are you sure you want to reset this users password?",
  "userManagement.selectAll": "Select All",
  "userManagement.deselectAll": "Deselect All",
  "userManagement.edit": "edit",
  "userManagement.resetUserPasswordSuccess": "Password has been reset",
  "userManagement.resetUserPasswordFail": "Failed to reset password",
  "userManagement.noEmail": "No Email",
  "userManagement.emails": "Emails",
  "userManagement.noPermissions": "No Permission Groups",
  "userManagement.permissionGroup": "Permission Group",
  "userManagement.portal": "Portal Access",
  "userManagement.policyGroupName": "Group Name",
  "userManagement.createPermissionGroup": "Create Permission Group",
  "userManagement.approveUser": "Approve User",
  "userManagement.selectPortalsToAccess": "Select the portals they can access:",
  "userManagement.pendingUsers": "Pending Users",
  "userManagement.approved": "User Approved",
  "userManagement.errorApproving": "Error Approving User, Contact Support",
  //Settings
  "settings.companySettings": "Company Settings For",
  "settings.userSettings": "User Settings",
  "settings.preferredAisle": "Putaway Preferred Aisle",
  "settings.defaultPWHF": "Default Warehouse",
  "settings.warehouse": "Warehouse",
  "settings.zone": "Zone",
  "settings.aisle": "Aisle",
  "settings.markShipmentWRPicPrivate":
    "Automatically mark warehouse receipt pictures private",
  "settings.markShipmentShipPicPrivate":
    "Automatically mark shipment pictures private",
  "settings.holdShipMarkupSanityCheck":
    "Shipments that have items marked above this % be automatically marked as held",
  "settings.holdShipMarkup": "Percent Held",
  "settings.adHocOnly": "All warehouse receipts should be ad-hoc",
  "settings.standardOnly": "All warehouse receipts should be standard",
  "settings.ediInProduction": "EDI documents production mode",
  "settings.WRRequireCartonWeights": "Weigh cartons upon receipt",
  "settings.holdShipmentWithNotes":
    "Shipments sent with notes should be marked held initially",
  "settings.confirmPicUpload": "Confirm picture before upload",
  "settings.preferences": "Preferences",
  "settings.costManagement": "Price List",
  "settings.billing": "Billing",
  "settings.updated": "Settings Saved",
  "settings.exportCompliance":
    "Should items added to shipments be checked for export (from US) compliance",
  "settings.SERVICEINV_WIRING_INSTRUCTIONS":
    "Service Invoice Wiring Instructions",
  "settings.SERVICEINV_PAY_TO_ADDRESS": "Service Invoice Pay To Address",
  "settings.wiringInstructions": "Wiring instructions for service invoice",
  "settings.payToAddress":
    "The address service invoice payments should be paid to",
  // Company
  "general.allCompanies": "All Companies",
  "company.groups": "Company Groups",
  "company.addUserToCompanyGroup": "Add User to Company Group",
  "company.updateCompany": "Update Company",
  "company.created": "Company Created",
  "company.notCreated": "Unable to Create Company",
  "company.MANUFACTURER": "Manufacturer",
  "company.RESELLER": "Reseller",
  "company.THIRD_PARTY_LOGISTICS": "3PL",
  "company.CARRIER": "Carrier",
  "company.CUSTOMER": "Customer",
  "company.CUSTOMER_AD_HOC": "Customer Ad Hoc",
  "company.CUSTOMER_AD_HOC_PLUS": "Customer Ad Hoc Plus",
  "company.CUSTOMER_CAB": "Customer Cab",
  "company.CUSTOMER_CONSOLIDATION": "Customer Consolitation",
  "company.CUSTOMER_DISTRIBUTION": "Customer Distribution",
  "company.DISTRIBUTOR": "Distributor",
  "company.END_USER": "End User",
  "company.IMPORTER": "Importer",
  "company.MANUFACTURE": "Manufacturer",
  "company.PWHF": "PWHF",
  "company.SHIPPER": "Shipper",
  "company.SUPPLIER": "Supplier",
  "company.TRUCKER": "Trucker",
  "company.VENDOR": "Vendor",
  "company.name": "Company Name",
  "company.class": "Company Class",
  "company.addNewAddress": "Add New Address",
  "company.createCompany": "Add New Company",
  "company.newDistributionList": "New Distribution List",
  "company.updateDistributionList": "Update Distribution List",
  "company.howToAddToDL": "Click on email to add to Distribution List",
  "company.howToAddToCG": "Click on email to add to Company Group",
  "company.addToDL": "Email To Add To List",
  "company.removeEmail": "Email Removed",
  "company.unableToRemoveEmail": "Unable to Remove Email",
  "company.emailAdded": "Email Added",
  "company.unableToAddEmail": "Unable to Add Member",
  "company.address": "Physical Address",
  "company.addAddress": "Add Address",
  "company.addressDeleted": "Address Deleted",
  "company.updateAddress": "Update Address",
  "company.addressType": "Address Type",
  "company.putawayPreference": "Putaway Preference",
  "company.overview": "Overview",
  "company.shipmentHandling": "Shipment Markup",
  "company.dlName": "Name",
  "company.dlMembers": "Members",
  "company.notificationEvents": "Notification Events",
  "company.notificationsUpdated": "Notifications Updated",
  "company.unableToUpdateNotifications": "Unable to Update Notifications",
  "company.event": "Event",
  "company.editNotifications": "Edit Notification Events",
  "company.generalBilling": "General Billing",
  "company.overviewExplicitCompanyChoice":
    "Choose a Company in the Company Options to view Company Details",
  "company.generalBillingDescription":
    "The General Billing tab displays our default Price Lists and Services based on out different warehouse locations throughout the world. To display Price Lists for a certain company, select a company in the Company Options in the top right of the screen.",
  "company.preferences": "Preferences",
  "company.addresses": "Addresses",
  "company.addressUpdated": "Address Updated",
  "company.moreAddresses": "Show More Addresses",
  "company.billing": "Billing",
  "company.staff": "Staff",
  "company.distributionLists": "Distribution Lists",
  "company.dlCreated": "Distribution List Created",
  "company.events": "Events",
  "company.website": "Website",
  "company.tin": "TIN",
  "company.code": "Code",
  "company.billingRatesPricing": "Billing Rates and Pricing",
  //timezone
  "timezone.promptUpdateTimezone":
    "Would you like to see times in your local timezone, {timezone}?",
  //billing
  "billing.style": "Billing Style",
  "billing.isSpecialRate": "Special Rate",
  "billing.rate": "Rate %",
  "billing.ratePerPound": "Rate % /LB",
  "billing.dayLows": "Day Lows",
  "billing.dayHigh": "Day Highs",
  "billing.minCharge": "Min Charge",
  "billing.chargeable": "Chargeable",
  "billing.storageBilling": "Storage Tier",
  "billing.contiguousWarning": "Complete Proper Day Range",
  "billing.updatedStorageTier": "Updated Storage Tier",
  "billing.updatedAddedValue": "Updated Added Value",
  "billing.storageStartDate": "Storage Start Date",
  "billing.lowMark": "Low Mark Shipment Value",
  "billing.handlingCharge": "Handling Charge / LB",
  "billing.fixedRate": "Fixed Rate",
  "billing.billingProfileAddedValue": "Added Value",
  "billing.minimumCharge": "Minimum Charge",
  "billing.usdPerPound":
    "Configure the Charge Code PIKUP using the rate ($USD)/LB",
  "billing.usdPerCargoValue": "($ USD)/Cargo Value",
  "billing.threeVRate": "3V / INLAND FREIGHT",
  "billing.fourVRate": "4V / CARGO INSURANCE",
  "billing.intlTxnFee": "INTL TXN FEE",
  "billing.primaryAddress": "Primary Address",
  "billing.separateInvoiceBilling": "Separate Invoice Billing Address",
  "billing.valueAddedService": "Value Added Service",
  "billing.handling": "Handling",
  "billing.selectedService": "Selected",
  "billing.service": "Service",
  "billing.justRate": "Rate",
  "billing.cargoInsurance": "Cargo Insurance",
  "billing.inlandFreight": "Inland Freight",
  "billing.unableToApplyCosts": "Unable to Apply Costs",
  "billing.chargeCode": "Charge Code",
  "billing.description": "Description",
  "billing.category": "Category",
  "billing.itemType": "Item Type",
  "billing.unitOfMeasure": "Unit of Measure",
  "billing.isAutomated": "Automated",
  "billing.cost": "Cost ($ USD)",
  "billing.sell": "Sell ($ USD)",
  "billing.minSell": "Minimum Sell ($ USD)",
  "billing.storageFilter": "STORAGE",
  "billing.receivingFilter": "RECEIVING",
  "billing.shippingFilter": "SHIPPING",
  "billing.otherFilter": "OTHER",
  "billing.consumableFilter": "CONSUMABLE",
  "billing.serviceFilter": "SERVICE",
  "billing.invalidSellRate": "Invalid Sell Rate",
  "billing.automaticallyCalculated": "Automatically Calculated",
  //Error
  "error.invalidCustomer": "Select a Customer",
  "error.invalidCarrier": "Select a Carrier",
  "error.invalidShipper": "Select a Shipper",
  "error.invalidCustomerPO": "Enter Customer PO",
  "error.invoice": "Select NA or enter invoice number and Date",
  "error.errorPersonalInfo": "Unable to retrieve personal info",
  "error.networkError": "There is a network issue, please try again later",
  "error.whsReceipt.param": "Select a Warehouse Receipt",
  "error.purchaseOrder.param": "Select a Purchase Order",
  "error.shipment.param": "Select a Shipment",
  "error.create.shipment": "Unable to Create Shipment",
  //Items
  "item.partNumber": "Part Number",
  "item.cartonCount": "Carton Count",
  "item.quantityEach": "Quantity",
  "item.coo": "COO",
  "item.condition": "Condition",
  "item.serials": "Contains Serials",
  "item.wood": "Contains Wood",
  "item.battery": "Contains Battery",
  "item.hazmat": "Hazmat",
  "item.length": "Length",
  "item.width": "Width",
  "item.height": "Height",
  "item.weightKgs": "Weight Kgs",
  "item.subCartonCount": "Subcarton Count",
  "item.subcartonsPerCarton": "Subcartons per Carton",
  "item.hasWood": "Wood",
  "item.hasBattery": "Battery",
  "item.hasSerials": "Serials",
  "item.cartonDimensions": "Carton Dimensions",
  "item.addItem": "Add Item",
  "item.updateItem": "Update Item",
  "item.partIdentifier": "Part Identifier",
  "item.qtyPerCarton": "Qty Per Carton",
  "item.isOverage": "Overage",
  "item.isShort": "Short",
  "item.isDamaged": "Damaged",
  "item.updated": "Item Updated",
  "item.purchaseOrder": "Purchase Order",
  "item.partNumberPlaceholder": "Search...",
  "item.expirationDate": "Expiration Date",
  "item.unableToCountCartons": "Unable to Count Cartons",
  "item.lotNumber": "Lot Number",
  //serviceItems
  "serviceItem.buildPalletsCargo": "Build Pallets for Cargo",
  "serviceItem.buildPalletsOcean": "Build Pallets for Ocean",
  "serviceItem.buildPalletsPax": "Build Pallets for Pax",
  "serviceItem.collectSerials": "Collect Serials",
  "serviceItem.releaseCartonsLoose": "Release Cartons Loose",
  "serviceItem.releasePalletFw": "Release Pallet FW",
  "serviceItem.releasePalletNfw": "Release Pallet NFW",
  "serviceItem.releasePalletPlastic": "Release Pallet Plastic",
  "serviceItem.releasePalletPresswood": "Release Pallet Presswood",
  "serviceItem.shrinkWrapClear": "Shrink Wrap Clear",
  "serviceItem.shrinkWrapOpaque": "Shrink Wrap Opaque",
  //Cost management
  "costManagement.item": "Item",
  "costManagement.type": "Type",
  "costManagement.uom": "UoM",
  "costManagement.enabled": "Enabled",
  "costManagement.cost": "Cost",
  "costManagement.sell": "Sell",
  "costManagement.minSell": "Min Sell",
  //Skid management
  "skidManagement.new": "New Skid",
  "skidManagement.skid": "Skid",
  "skidManagement.identifier": "Skid Identifier",
  "skidManagement.skidCreated": "Skid Created",
  "skidManagement.movedSkid": "Skid Moved",
  //Files
  "file.add": "Add Files",
  "file.dropZoneText": "Drag and drop a file here or click",
  "file.dropZonePreviewText": "Preview",
  "files.maxSizeExceeded": "Files are too big",
  "files.someFilesWereNotAdded": "Some files were not uploaded",
  "files.allFilesUploaded": "All Files Uploaded",
  "files.unableToUploadFiles": "Unable to upload files",
  // Work Orders
  "workOrder.newWorkOrder": "New Work Order",
  "workOrder.details": "Work Order Details",
  "workOrder.orderID": "Work Order ID",
  "workOrder.status": "Task Status",
  "workOrder.requestDate": "Requested On",
  "workOrder.updateDate": "Last Updated On",
  "workOrder.requestor": "Requested By",
  "workOrder.requestorContact": "Requestor Email",
  "workOrder.assignee": "Assigned To",
  "workOrder.assignTo": "Assign Task To",
  "workOrder.created": "Created Work Order",
  "workOrder.subtasks": "Subtasks",
  "workOrder.taskNumber": "Work Order ID",
  "workOrder.notes": "Notes",
  "workOrder.addSubTask": "Add Sub Task",
  "workOrder.warehouse": "Warehouse",
  "workOrder.customer": "Customer",
  "workOrder.subTaskDetails": "Sub Task Details",
  "workOrder.assigned": "Work Order Assigned",
  "workOrder.assignedSubTask": "Sub Task Assigned",
  "workOrder.deleted": "Work Order Deleted",
  "workOrder.unableToDeleteWorkOrder": "Unable to Delete Work Order",
  "workOrder.start": "Start Task",
  "workOrder.pause": "Pause Task",
  "workOrder.complete": "Complete Task",
  "workOrder.reopen": "Reopen Task",
  "workOrder.cannotReassignActive":
    "Cannot Reassign Active Work Order, Pause to Reassign",
  "workOrder.hoursWorked": "Work Hours",
  "workOrder.mainTask": "Main Task",
  "workOrder.allTasks": "All Tasks",
  "carton.availableTimestamp": "Available",
  "carton.inspectionTimestamp": "Inspected On",
  "carton.majorLine": "Major Line",
  "carton.identifier": "Carton ID",
  "carton.location": "Location",
  "carton.customer": "Customer",
  "carton.warehouseReceipt": "Warehouse Receipt",
  "carton.shipment": "Shipment",
  "carton.skid": "Skid",
  "carton.vendorCarton": "Vendor Carton ID",
  "carton.weight": "Weight (Kgs)",
  "carton.warehouse": "Warehouse",
  "carton.receivedOn": "Received On",
  "carton.details": "Carton Details",
  "carton.inboundCarrier": "Inbound Carrier",
  "carton.trackingNumber": "Tracking Number",
  "carton.subCartonCount": "Sub-Cartons Count",
  "carton.height": "Height",
  "carton.length": "Length",
  "carton.width": "Width",
  "carton.inches": "Inches",
  "carton.centimeters": "Centimeters",
  "carton.weightMeasurement": "Weight",
  "carton.grosslbs": "Lbs",
  "carton.grosskgs": "Kgs",
  "carton.skidNumber": "Number",
  "carton.skidLocation": "Location",
  "carton.changeCartonLocation": "Change Carton Location",
  "carton.hasLithium": "Lithium",
  "carton.isHazmat": "Hazmat",
  "carton.isScreened": "Screened",
  "carton.isSubCarton": "Sub-Carton",
  "carton.isWoodPackaging": "Contains Wood",
  "carton.isInspected": "Inspected",
  "carton.isReturned": "Carton Returned",
  "carton.items": "Items",
  "carton.subcartons": "Sub-Cartons",
  "carton.line": "LIN",
  "carton.partNumber": "Part Number",
  "carton.quantity": "Quantity",
  "carton.weightLbs": "Weight (Lbs)",
  "carton.serialNumbers": "Serial Numbers",
  "storage.createLocations": "Create Locations",
  "storage.createWTemplate": "Create Locations with Template",
  "storage.createLocationManually": "Create Location Manually",
  "storage.downloadLocationTemplate": "Download Locations Template",
  "storage.cartons": "Cartons",
  "storage.skids": "Skids",
  "storage.moveCartonRecordType": "Choose Where to Move Carton",
  "storage.moveSkid": "Move Skid",
  "storage.moveCarton": "Move Carton",
  "storage.moveSkidTo": "Move Skid To:",
  "storage.moveCartonTo": "Move Carton To:",
  "storage.moveSkidSuccess": "Moved Skid Successfully",
  "storage.moveSkidError": "Unable to move Skid to given destination",
  "storage.moveCartonSuccess": "Moved Carton Successfully",
  "storage.moveCartonError": "Unable to move Carton to given destination",
  "storage.destination": "Destination",
  "storage.location": "Locations",
  "location.errorDelete": "Unable to Delete Location",
  "location.depth": "Depth (in)",
  "location.locationType": "Location Type",
  "location.cartonCount": "Cartons in Location",
  "location.looseCartons": "Loose Cartons",
  "location.identifier": "Location Name",
  "location.warehouse": "Warehouse",
  "location.aisle": "Aisle",
  "location.column": "Column",
  "location.numberOfSkids": "Skids in Location",
  "location.level": "Level",
  "location.slot": "Slot",
  "location.dedicatedCustomer": "Dedicated Customer",
  "location.details": "Location Details",
  "location.skidCartons": "Cartons in Location Skids",
  "location.forklift": "Forklift",
  "location.requiresForklift": "Requires Forklift",
  "location.multipleSkids": "Multiple Skids in Location",
  "skid.identifier": "Skid",
  "skid.details": "Skid Details",
  "skid.location": "Location",
  "skid.zone": "Zone",
  "skid.grossKgs": "Gross Kgs",
  "skid.grossLbs": "Gross Lbs",
  "skid.cartonCount": "Carton Count",
  "sidebar.skid": "Skid",
  "skid.cartons": "Cartons",
  "sidebar.ticket": "Tickets",
  "ticket.ticket": "Ticket",
  "ticket.status": "Status",
  "ticket.closeTicket": "Close Ticket",
  "ticket.lastUpdatedTimestamp": "Last Updated On",
  "ticket.comment": "Write a Comment",
  "ticket.files": "View Ticket Files",
  "ticket.identifier": "Ticket Number",
  "ticket.references": "Ticket References",
  "ticket.isResolved": "Resolved",
  "ticket.updatedBy": "Last Updated by",
  "ticket.details": "Latest Details",
  "ticket.liveUpdates": "Live Updates",
  "ticket.commentTicket": "Comment",
  "ticket.resolve": "Resolve Ticket",
  "ticket.resolveWComment": "Resolve with Comment",
  "ticket.unresolve": "Reopen Ticket",
  "ticket.unresolveWComment": "Reopen with Comment",
  "Ticket.warehouse": "Warehouse",
  "handlingUnit.identifier": "ID",
  "handlingUnit.warehouse": "Warehouse",
  "handlingUnit.hoursAging": "Pending Hours",
  "handlingUnit.inboundCarrier": "Inbound Carrier",
  "handlingUnit.createdBy": "Created By",
  "handlingUnit.handlingUnitType": "Piece Type",
  "handlingUnit.received": "Received On",
  "handlingUnit.receivedPackage": "Received",
  "handlingUnit.inboundCarrierFilter": "Filter by Inbound Carrier",
  "handlingUnit.notFound": "❌ Handling Unit Not Found",
  "handlingUnit.found": "✅ Handling Unit Found"
};
